/*
 后台管理系统主路由组件
 */
import React, {Component} from 'react'
import {Layout} from 'antd';
import {Switch, Route, Redirect} from 'react-router-dom'

import userUtils from '../../utills/userUtils'

import SiderMenu from '../../components/sider/sider'
import HeaderMenu from '../../components/header/header'
import OrderTicket from '../order-ticket/order-ticket'
import TrackList from '../track-list/track-list'
import TrackEdit from '../track-edit'
import MainPage from '../main-page/main-page'
import TrackInfo from '../trackInfo/trackInfo'
import OrderInfo from '../order-info/order-info'
import AddrList from '../address/addr-list'
import CompanyList from '../company/company-list'
import CompanyAdd from '../company/company-add'
import CompanyUpdate from '../company/company-update'
import AddrAdd from '../address/addr-add'
import DeliveryList from '../delivery-info/delivery-list'
import DeliveryDetail from '../delivery-info/delivery-detail'
import DeliveryEdit from '../delivery-info/delivery-edit'
import './main.less'
import UserSublistForm from "../subscribe/user-sublist";
import OrderSubForm from "../subscribe/order-sub-set";
const {Content, Footer} = Layout;

export default class Main extends Component {
    render() {

        const user = userUtils.user
        // 如果内存没有存储user ==> 当前没有登录
        if (!user) {
            // 自动跳转到登录(在render()中)
            return <Redirect to='/login'/>
        }
        return (
            <Layout style={{minHeight: '100%'}}>
                <SiderMenu/>
                <Layout>
                    <HeaderMenu/>
                    <Content
                        style={{
                            margin: '24px 16px',
                            padding: 24,
                            background: '#fff',
                            minHeight: 280,
                        }}
                    >
                        <Switch>
                            <Route path='/orderTicket' component={OrderTicket}/>
                            <Route path='/trackInfo' component={TrackInfo}/>
                            <Route path='/orderInfo' component={OrderInfo}/>
                            <Route path='/trackEdit' component={TrackEdit}/>
                            <Route path='/trackList' component={TrackList}/>
                            <Route path='/addrList' component={AddrList}/>
                            <Route path='/companyList' component={CompanyList}/>
                            <Route path='/deliveryList' component={DeliveryList}/>
                            <Route path='/deliveryDetail' component={DeliveryDetail}/>
                            <Route path='/deliveryEdit' component={DeliveryEdit}/>
                            <Route path='/addrAdd' component={AddrAdd}/>
                            <Route path='/companyAdd' component={CompanyAdd}/>
                            <Route path='/companyUpdate' component={CompanyUpdate}/>
                            <Route path='/usersub' component={UserSublistForm}/>
                            <Route path='/ordersub' component={OrderSubForm}/>
                            <Route path='/' component={MainPage}/>
                        </Switch>
                    </Content>
                    {/*<Footer style={{ textAlign: 'center' }}>阳光捷通(北京)贸易服务有限公司</Footer>*/}
                </Layout>
            </Layout>
        )
    }
}